import { getUsers } from "../../../services/api-server/user";
import { LookupConfig } from "../../find_unique_ids_in_list";

export function createAuditLookupConfig(): LookupConfig[] {
	return [
		{
			fetch: (emailList: any[]) => getUsers(emailList) as Promise<any[] | null>,
			sourceKey: "auditor",
			targetKey: "email",
			outputKey: "auditor_name",
			transform: (item: any) => item?.name,
		},
		{
			fetch: (emailList: any[]) => getUsers(emailList) as Promise<any[] | null>,
			sourceKey: "reviewer",
			targetKey: "email",
			outputKey: "reviewer_name",
			transform: (item: any) => item?.name,
		},
		{
			fetch: (emailList: any[]) => getUsers(emailList) as Promise<any[] | null>,
			sourceKey: "primary_author",
			fallbackSourceKey: "author",
			targetKey: "email",
			outputKey: "author_name",
			transform: (item: any) => item?.name,
		},
	];
}
